// Module
var code = " <div id=\"grid\" class=\"stretch\"></div> <button mat-icon-button=\"\" (click)=\"openSettings()\" class=\"settings-btn\" matTooltip=\"{{'lbl_table_settings' | translate}}\" *ngIf=\"displaySettings\"> <mat-icon svgIcon=\"gh:grid-settings\"></mat-icon> </button> ";
// Exports
module.exports = code;